export const crearTipoCitaVacio = (valores = {}) => ({
  IdTiposCita: null,
  Nombre: "",
  MontoASumar: "",
  Descuento: 0,
  ...valores
});
